import React, { useContext, useEffect, useState } from 'react';
import {
  Grid,
  IconButton,
  InputAdornment,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import { Visibility, VisibilityOff, VpnKey, Edit } from '@material-ui/icons';

import { useHistory } from 'react-router-dom';

import moment from 'moment';

import { Formik } from 'formik';

import PropTypes from 'prop-types';

import BasicButton from '../../buttons/basicButton';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { newPatient, updatePatient } from '../../../utils/comms';
// import { heightUnits, weightUnits } from '../../../utils/constants';
import { newPatientDetailsVS, updatePatientDetailsVS } from '../../../utils/formValidations';

import translations from '../../../languages/i18n';

import { SessionContext } from '../../../utils/context';

export default function PatientDetails({ type, detailsData, handleFeedback, handleShowChangePassword }) {
  const sessionContext = useContext(SessionContext);

  const [disableUsername, setDisableUsername] = useState(true);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showEdit, setshowEdit] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();

  useEffect(() => {    
    if (type === 'edit' && !detailsData.HUSE_patient_id) { // Si HUSE_patient_id no existeix, és null o "" !detailsData.HUSE_patient_id serà true
      setshowEdit(true);
    }
  }, []);
  

  const goBack = () => {
    history.goBack();
  };

  const onChangePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onChangeConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const toggleChangeUsername = () => {
    setDisableUsername(!disableUsername);
  };

  // Per interrompre la 'bubble' i evitar que el navegador executi el seu comportament habitual davant d'aquest event
  const onMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onMouseDownUsername = (event) => {
    event.preventDefault();
  };

  const updateData = async (values, resetForm) => {
    setShowLoading(true);
    let response = null;
    const patient = {
      username: values.username,
      password: values.password,
      // email: values.email,
      birthdate: values.birthdate,
      height: values.height,
      weight: values.weight,
      // events: values,
    };
    if (values.sex) { patient.sex = values.sex; } // Sex només pot ser M o W qualsevol altre valor ('', null, ...) dona error al servidor
    if (type === 'new') {
      response = await newPatient({ patient }, sessionContext.userToken);
    } else {
      // setSentValues(values); // En cas de fer un edit, en refrescar la pantalla es mostrarà el formulari amb les dades enviades
      response = await updatePatient({ patient }, detailsData._id, sessionContext.userToken);
    }
    setShowLoading(false);
    if (response.status === 200) { // Pacient creat/modificat
      if (type === 'new') resetForm(); // En cas de crear un nou pacient, en mostrar la pantalla es mostrarà el formulari buit
      setShowConfirmPassword(false); // Ho tornam al valor inicial, per si l'usuari ho havia deixat en mode mostrar contrasenya
      setShowPassword(false);
      setDisableUsername(type === 'edit' ? true : false); // Si estavem editant les dades del pacient, en refrescar el formulari el nom d'usuari ha d'estar deshabilitat
      handleFeedback('success', type === 'new' ? 'NewPatient' : 'UpdatePatient');
    } else if (response === 'timeOut') { // El servidor està caigut o l'usuari no té connexió
      handleFeedback('error', 'TimeOut');
    } else if (response === 400) { // Ja hi ha un usuari amb aquest nom
      handleFeedback('error', type === 'new' ? 'NewPatientAlreadyExists' : 'UpdatePatientAlreadyExists');
    } else { // Error amb les dades o al servidor
      handleFeedback('error', type === 'new' ? 'NewPatient' : 'UpdatePatient');
    }
  };

  return (
    <Formik
      initialValues={type === 'new' ? {
        _id: '',
        username: '',
        // email: '',
        password: '',
        confirmPassword: '',
        birthdate: '',
        sex: '',
        // height: '',
        // weight: '',
        // events: [],
      } : {
        _id: detailsData ? detailsData._id : '', // Per evitar un error quan es fa un reload de la pestanya del navegador, comprovam que detailsData existeix abans d'intentar agafar-ne cap valor. Si no exiteix posam '' dins la propietat per evitar warnings
        username: detailsData ? detailsData.username : '', // Idem
        // email: detailsData ? detailsData.email : '', // Idem
        password: '',
        confirmPassword: '',
        birthdate: detailsData ? detailsData.birthdate : '', // Idem
        sex: detailsData ? detailsData.sex : '', // Idem
        // height: detailsData ? detailsData.height : '', // Idem
        // weight: detailsData ? detailsData.weight : '', // Idem
        // events:  detailsData ? detailsData.height : [], // Idem
      }}
      validationSchema={type === 'new' ? newPatientDetailsVS : updatePatientDetailsVS }
      onSubmit={(values, { resetForm }) => { updateData(values, resetForm); }}
    >
      {({ values, touched, errors, handleChange, handleBlur, submitForm }) => (
        <React.Fragment>
          <SpinnerLoading show={showLoading} />
          <Grid item xs={6}>
            <Grid container direction='column' spacing={3}>
              <Grid item>
                <TextField
                  disabled
                  fullWidth
                  label={translations['_idUser']}
                  variant='outlined'
                  id='idUser'
                  name='idUser'
                  value={values._id}
                />
              </Grid>
              <Grid item>
                <TextField
                  disabled={type === 'new' ? false : disableUsername}
                  required
                  fullWidth
                  label={translations['_username']}
                  variant='outlined'
                  id='username'
                  name='username'
                  error={Boolean(touched.username && errors.username)}
                  value={values.username.replace(/\s/g, '')} // Per evitar que es puguin introduir espais en blanc
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.username && errors.username ? errors.username : ''}
                  InputProps={showEdit ? {
                      endAdornment: (
                        <InputAdornment>
                          <IconButton
                            onClick={toggleChangeUsername}
                            onMouseDown={onMouseDownUsername}
                            edge='end'
                          >
                            <Edit />
                          </IconButton>
                        </InputAdornment>
                      ),
                    } : null}
                />
              </Grid>
              {/* <Grid item>
                <TextField
                  fullWidth
                  label={translations['_email']}
                  variant='outlined'
                  id='email'
                  name='email'
                  error={Boolean(touched.email && errors.email)}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  helperText={touched.email && errors.email ? errors.email : ''}
                />
              </Grid> */}
              {type === 'new' ? (
                <React.Fragment>
                  <Grid item>
                    <TextField
                      required
                      fullWidth
                      type={showPassword ? 'text' : 'password'}
                      variant='outlined'
                      id='password'
                      name='password'
                      label={translations['_password']}
                      error={Boolean(touched.password && errors.password)}
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.password && errors.password ? errors.password : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={onChangePasswordVisibility}
                              onMouseDown={onMouseDownPassword}
                              edge='end'
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <TextField
                      required
                      fullWidth
                      type={showConfirmPassword ? 'text' : 'password'}
                      variant='outlined'
                      id='confirmPassword'
                      name='confirmPassword'
                      label={translations['_confirmPassword']}
                      error={Boolean(touched.confirmPassword && errors.confirmPassword)}
                      value={values.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={onChangeConfirmPasswordVisibility}
                              onMouseDown={onMouseDownPassword}
                              edge='end'
                            >
                              {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Grid item>
                    <TextField
                      disabled
                      // required
                      fullWidth
                      type='password'
                      variant='outlined'
                      id='changePassword'
                      name='changePassword'
                      label={translations['_password']}
                      value='000000' // Cadena per a que es mostrin 6 bullets al camp de password
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={handleShowChangePassword}
                              onMouseDown={onMouseDownPassword}
                              edge='end'
                            >
                              <VpnKey />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container direction='column' spacing={0}>
              <Grid item>
                <Grid container direction='row' justify='space-between' spacing={2}>
                  <Grid item xs={6}>
                    <FormControl fullWidth component='fieldset'>
                      <FormLabel component='legend'>{translations['_sex']}</FormLabel>
                      <RadioGroup row id='sex' name='sex' value={values.sex} onChange={handleChange}>
                        {/* L'style dels FormControlLables és necessari per evitar que en castellà (segurament per falta d'espai) es produexi un desplaçament cap avall dels TextField que hi ha en els Grid Items inferiors */}
                        <FormControlLabel style={{ margin: 0 }} value='M' control={<Radio color='primary' />} label={translations['_man']} />
                        <FormControlLabel style={{ margin: 0 }} value='W' control={<Radio color='primary' />} label={translations['_woman']} />
                        <FormControlLabel style={{ margin: 0 }} value='O' control={<Radio color='primary' />} label={translations['_otherSex']} />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label={translations['_birthdate']}
                      variant='outlined'
                      type='date'
                      id='birthdate'
                      name='birthdate'
                      value={moment(values.birthdate).format('YYYY-MM-DD')} // Per adequar el format de la data al que necessita el TextField
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ max: new Date().toISOString().split('T')[0] }} // Per evitar que es pugui introduir una data posterior al dia actual
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              {/*
              <Grid item>
                <Grid container direction='row' justify='space-between' spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant='outlined'
                      id='height'
                      name='height'
                      label={translations['_height']}
                      error={Boolean(touched.height && errors.height)}
                      value={values.height}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.height && errors.height ? errors.height : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>{heightUnits}</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant='outlined'
                      id='weight'
                      name='weight'
                      label={translations['_weight']}
                      error={Boolean(touched.weight && errors.weight)}
                      value={values.weight}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      helperText={touched.weight && errors.weight ? errors.weight : ''}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>{weightUnits}</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              */}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2} direction='row' justify='center'>
              <Grid item>
                <BasicButton handleClick={submitForm} type='accept' />
              </Grid>
              <Grid item>
                <BasicButton handleClick={goBack} type='cancel' />
              </Grid>
            </Grid>
          </Grid>
        </React.Fragment>
      )}
    </Formik>
  );
}

// Indica i controla els props que se han de passar al component
PatientDetails.propTypes = {
  detailsData: PropTypes.object.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  handleShowChangePassword: PropTypes.func,  
  type: PropTypes.string.isRequired,
};
